import {Directive, ElementRef, HostListener, inject} from '@angular/core';

@Directive({
  selector: '[covRevealFixedTopBar]',
})
export class RevealFixedTopBarDirective {
  private topBar = inject(ElementRef).nativeElement;
  private container = this.topBar.closest('.cov-content-container');
  private prevScroll = 0;
  private curScrollPosY = 0;
  private topBarHeight = 75; // Same as --application-top-bar-height as CSS variable

  @HostListener('window:scroll')
  onDocumentMousewheelEvent() {
    this.curScrollPosY = window.scrollY;

    if (this.container) {
      if (this.curScrollPosY < this.prevScroll) {
        this.container.classList.add('top-bar-fixed');
        this.topBar.classList.add('reveal');
      } else {
        this.container.classList.remove('top-bar-fixed');
        this.topBar.classList.remove('reveal');
      }
    }

    if (this.curScrollPosY >= this.topBarHeight) {
      this.topBar.classList.add('cover-content');
    } else {
      this.topBar.classList.remove('cover-content');
    }

    this.prevScroll = this.curScrollPosY;
  }
}
